import React, { Fragment } from 'react';
import { Row } from 'react-bootstrap';
import Radio, { RadioGroup } from '../../../components/Radio';
import SelectableCard from '../../../components/SelectableCard';
import TextInput from '../../../components/TextInput';

export type StepProps = {
  data: any;
  collectStepData: (data: any) => void;
};

const VerifyDependentStep1 = ({ data, collectStepData }: StepProps) => {
  const handleChangeCardChange = (e: string | number) => {
    collectStepData({
      ...data,
      dependentRelationship: e,
      dependentRelationshipText: '',
    });
  };

  const handleChangeDisabled = (e: string | number) => {
    collectStepData({
      ...data,
      isDisabled: e,
    });
  };

  const handleChangeIsStudent = (e: string | number) => {
    collectStepData({
      ...data,
      isFullTimeStudent: e,
    });
  };

  const handleFullTimeStudent = (e: string | number) => {
    collectStepData({
      ...data,
      semesterLength: e,
    });
  };

  const inputOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    collectStepData({
      ...data,
      dependentRelationshipText: e.target.value,
    });
  };

  return (
    <Fragment>
      <section className={'mt-11 pt-2 pt-lg-1'}>
        <h5 className={'h5 mb-0'}>
          Select the option that best describes your relationship with the
          dependent
        </h5>
        <div className={'mt-6 mt-lg-10'}>
          <RadioGroup
            name={'step-1'}
            value={data.dependentRelationship}
            onChange={handleChangeCardChange}
          >
            <SelectableCard
              title="Biological child"
              subtitle1="You are the birth mother or birth father of the child"
              radioButtonValue="1"
              selected={data.dependentRelationship === '1'}
            />
            <SelectableCard
              title="Adopted child"
              subtitle1="Child for whom you have completed the adoption process or who has been placed with you for adoption"
              radioButtonValue="2"
              selected={data.dependentRelationship === '2'}
            />
            <SelectableCard
              title="Stepchild"
              subtitle1="Biological child of your eligible spouse"
              radioButtonValue="3"
              selected={data.dependentRelationship === '3'}
            />
            <SelectableCard
              title="Biological child of domestic partner"
              subtitle1="Biological child of your eligible domestic partner"
              radioButtonValue="4"
              selected={data.dependentRelationship === '4'}
            />
            <SelectableCard
              title="Permanent legal guardianship/custody"
              subtitle1="You or your eligible spouse or eligible domestic partner are the court-appointed legal guardian or custodian of the child"
              radioButtonValue="5"
              selected={data.dependentRelationship === '5'}
            />
            <SelectableCard
              title="None of the above"
              subtitle1="Please provide explanation"
              radioButtonValue="6"
              selected={data.dependentRelationship === '6'}
            >
              <div className={'ms-lg-13 pb-10 px-10 px-lg-13 lh-xs'}>
                <TextInput
                  placeholder={'Relationship'}
                  value={data.dependentRelationshipText}
                  onChange={inputOnChange}
                />
              </div>
            </SelectableCard>
          </RadioGroup>
        </div>
      </section>
      <section className={'pt-3 pt-lg-5'}>
        <h5 className={'h5 mb-0'}>Disabled</h5>
        <div className={'mt-7 mt-lg-10'}>
          <h6 className={'text-fs-6'}>
            Is your dependent considered totally and permanently disabled?
          </h6>
          <div>
            <RadioGroup
              name={'step-1a'}
              value={data.isDisabled}
              onChange={handleChangeDisabled}
            >
              <Radio
                value={'yes'}
                id={'dtp-1'}
                label={'Yes'}
                className={'mt-10'}
              />
              <Radio
                value={'no'}
                id={'dtp-2'}
                label={'No'}
                className={'mt-10'}
              />
            </RadioGroup>
          </div>
        </div>
      </section>
      <section className={'mt-11 pt-lg-1'}>
        <h5 className={'h5 mb-0'}>
          Is the dependent a full-time* student at an accredited college of
          university?
        </h5>
        <div>
          <RadioGroup
            name={'step-1b'}
            value={data.isFullTimeStudent}
            onChange={handleChangeIsStudent}
          >
            <div
              className={`d-flex flex-column ${
                data.isFullTimeStudent === 'yes'
                  ? 'mt-10 nested-outer-radio-cnt'
                  : ''
              }`}
            >
              <Radio
                value={'yes'}
                id={'fscu-1'}
                label={'Yes'}
                className={'mt-10 radio-title'}
              />
              {data.isFullTimeStudent === 'yes' && (
                <Row className="nested-inner-radio-cnt">
                  <Row className={'px-0'}>
                    <h6>Are your semesters less than 12-hour?</h6>
                  </Row>
                  <RadioGroup
                    name={'full-time-student'}
                    value={data.semesterLength}
                    onChange={handleFullTimeStudent}
                  >
                    <Row className="pb-7 mt-6">
                      <Radio value={'1'} id={'fts-1'} label={'Yes'} />
                    </Row>
                    <Row>
                      <Radio value={'2'} id={'fts-2'} label={'No'} />
                    </Row>
                  </RadioGroup>
                </Row>
              )}
            </div>
            <Radio
              value={'no'}
              id={'fscu-2'}
              label={'No'}
              className={'mt-10'}
            />
          </RadioGroup>
        </div>
      </section>
    </Fragment>
  );
};

export default VerifyDependentStep1;
